export const containsWordInBrackets = (text) => {
    const regex = /\[.*?\]/;
    return regex.test(text);
};
